import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon, LayersIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { heroBenefits } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
const benefitIcons = [BookOpenIcon, LayersIcon, GiftIcon];
const assurances = ['Instant Digital Access', 'Ready-to-Use PDF Resources', 'Designed for Nail Educators', 'One-Time Payment'];
export function HeroSection() {
  return <section className="relative bg-brand-ivory px-5 pb-16 pt-12 lg:px-8 lg:pb-24 lg:pt-16" data-id="element-103" data-mp="1ucm66ai8aufx">
      <div className="mx-auto max-w-3xl text-center" data-id="element-104" data-mp="1qb0ugshfkm7b">
        <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold" data-id="element-105" data-mp="1q9pii5du0854">
          For Nail Educators, Instructors & Academy Owners
        </p>
        <h1 className="mt-6 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-106" data-mp="ex556qwtax2d">
          Stop Building Every Nail Class <Accent data-id="element-107" data-mp="38he7gwpzrckb">From Scratch.</Accent>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-[16px] leading-relaxed text-brand-charcoal/70 sm:text-[17px]" data-id="element-108" data-mp="38eibvf1m8zz1">
          Get a complete ready-to-teach system designed to help you explain techniques, demonstrate
          procedures, correct student mistakes, organize practice and assess progress — without
          spending hours creating your own teaching materials.
        </p>
      </div>

      <div className="relative mx-auto mt-10 w-full max-w-[1000px]" data-id="element-109" data-mp="2po0jxcoly8eq">
        <div aria-hidden="true" className="absolute inset-x-[6%] bottom-[4%] top-[18%] rounded-[50%] bg-brand-oatmeal opacity-80 blur-3xl" data-id="element-110" data-mp="2ui4q3tq1ucer" />
        <img src={MOCKUP_URL} alt="Nail Educator Ready — the complete set of six nail teaching volumes" width={1536} height={1024} loading="eager" decoding="async" className="relative mx-auto block w-full max-w-[560px] object-contain lg:max-w-[920px]" style={{
        filter: 'drop-shadow(0 34px 40px rgba(120, 96, 56, 0.22))'
      }} data-id="element-111" data-mp="2kpz2sxaqsj5w" />
      </div>

      <div className="mx-auto mt-10 max-w-4xl" data-id="element-112" data-mp="chkfmw85crco">
        <ul className="grid gap-7 border-y border-brand-charcoal/12 py-8 sm:grid-cols-3" role="list" data-id="element-113" data-mp="8haatmw3c6ze">
          {heroBenefits.map((benefit, index) => {
          const Icon = benefitIcons[index];
          return <li key={benefit.label} className="text-center" data-id="element-114" data-mp="108znt5mlu2vu" data-mpi={index}>
                <span className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-brand-paper" data-id="element-115" data-mp="106dcqw0i958v">
                  <Icon className="h-[18px] w-[18px] text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-116" data-mp="r7rqaprwx62t" />
                </span>
                <p className="mt-3 font-body text-[14px] font-semibold text-brand-charcoal" data-id="element-117" data-mp="m7vmaqj7ten9">{benefit.label}</p>
                <p className="mx-auto mt-1 max-w-[16rem] text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-118" data-mp="3bz20gumr8euf">
                  {benefit.description}
                </p>
              </li>;
        })}
        </ul>

        <CtaBlock label="Get Nail Educator Ready™" className="mt-10" data-id="element-119" data-mp="2wt4ki7ym7fb3" />
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" role="list" data-id="element-120" data-mp="31v3onk26ig93">
          {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-body text-[12px] text-brand-charcoal/60" data-id="element-121" data-mp="36rbz4k5fll9x">
              <CheckIcon className="h-3.5 w-3.5 text-brand-cta" strokeWidth={2.25} aria-hidden="true" data-id="element-122" data-mp="3bly7eeg7uxps" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}